<template>
  <header id="header" class="nuxt-header" :class="{ 'header--scrolled': isScrolled }">
    <div class="header-blur"></div>
    <div class="header-inner">
      <a class="header-logo" href="https://yohom.co.id">
        <img src="assets/img/logos/logo.png" alt="Yohom" />
      </a>

      <nav class="header-nav" :class="{ 'header-nav--open': mobileMenuOpen }">
        <ul class="nav-list">
          <li><router-link to="/" class="nav-item" @click="mobileMenuOpen = false">Beranda</router-link></li>
          <li><router-link to="/blog" class="nav-item" @click="mobileMenuOpen = false">Blog</router-link></li>
          <li><router-link to="/gabungmitra" class="nav-item" @click="mobileMenuOpen = false">Gabung Mitra</router-link></li>
          <li><router-link to="/daftarpesanan" class="nav-item" @click="mobileMenuOpen = false">Pesan Sekarang</router-link></li>
          <li><router-link to="/faq" class="nav-item" @click="mobileMenuOpen = false">FAQ</router-link></li>
        </ul>
        <a class="nav-cta" href="#footer" @click="mobileMenuOpen = false">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          Unduh Aplikasi
        </a>
      </nav>

      <!-- Mobile menu toggle -->
      <button class="mobile-toggle" @click="mobileMenuOpen = !mobileMenuOpen" aria-label="Toggle menu">
        <span class="toggle-bar" :class="{ 'toggle-bar--open': mobileMenuOpen }"></span>
        <span class="toggle-bar" :class="{ 'toggle-bar--open': mobileMenuOpen }"></span>
        <span class="toggle-bar" :class="{ 'toggle-bar--open': mobileMenuOpen }"></span>
      </button>
    </div>

    <!-- Mobile overlay -->
    <div class="mobile-overlay" :class="{ 'mobile-overlay--visible': mobileMenuOpen }" @click="mobileMenuOpen = false"></div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      mobileMenuOpen: false,
      isScrolled: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 10;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600;700&display=swap');

.nuxt-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  font-family: 'Public Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Frosted glass blur layer — sits behind the content */
.header-blur {
  position: absolute;
  inset: 0;
  /* background: rgba(255, 255, 255, 0.6); */
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* When scrolled — make the glass denser */
.header--scrolled .header-blur {
  background: rgba(255, 255, 255, 0.82);
  border-bottom-color: rgba(0, 0, 0, 0.08);
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.04),
    0 1px 2px -1px rgba(0, 0, 0, 0.03);
}

.header-inner {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  height: 64px;
}

.header-logo {
  display: flex;
  align-items: center;
}

.header-logo img {
  height: 30px;
  width: auto;
}

/* Navigation */
.header-nav {
  display: flex;
  align-items: center;
  gap: 4px;
}

.nav-list {
  display: flex;
  align-items: center;
  gap: 2px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  display: inline-flex;
  align-items: center;
  padding: 7px 13px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.15s ease;
  letter-spacing: -0.006em;
}

.nav-item:hover {
  color: #23d002;
  background: rgba(0, 0, 0, 0.04);
}

.nav-item.router-link-exact-active,
.nav-item.router-link-active {
  color: #059669;
  font-weight: 600;
}

.nav-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 12px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  background: #24d002;
  /* background: #18181b; */
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  letter-spacing: -0.006em;
}

.nav-cta:hover {
  background: #27272a;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

/* Mobile toggle button */
.mobile-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  padding: 8px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1001;
}

.toggle-bar {
  display: block;
  width: 18px;
  height: 2px;
  background: #374151;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.toggle-bar--open:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.toggle-bar--open:nth-child(2) {
  opacity: 0;
}

.toggle-bar--open:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

.mobile-overlay {
  display: none;
}

/* =============================
   Mobile responsive
   ============================= */
@media (max-width: 768px) {
  .header-inner {
    padding: 0 16px;
  }

  .mobile-toggle {
    display: flex;
  }

  .header-nav {
    position: fixed;
    top: 64px;
    right: 0;
    width: 280px;
    height: calc(100vh - 64px);
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
    gap: 8px;
    transform: translateX(100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-left: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.06);
  }

  .header-nav--open {
    transform: translateX(0);
  }

  .nav-list {
    flex-direction: column;
    align-items: stretch;
    gap: 2px;
  }

  .nav-item {
    padding: 12px 16px;
    font-size: 15px;
    border-radius: 8px;
  }

  .nav-cta {
    margin-left: 0;
    margin-top: 8px;
    justify-content: center;
    padding: 12px 18px;
    font-size: 14px;
  }

  .mobile-overlay {
    display: block;
    position: fixed;
    inset: 0;
    top: 64px;
    background: rgba(0, 0, 0, 0.2);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
    z-index: -1;
  }

  .mobile-overlay--visible {
    opacity: 1;
    pointer-events: auto;
  }
}
</style>